import { render } from "./TimeFrameInput.vue?vue&type=template&id=28563759"
import script from "./TimeFrameInput.vue?vue&type=script&lang=js"
export * from "./TimeFrameInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__